import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import type { TranslationKey } from "@/i18n/types";
import { useTranslation } from "react-i18next";

interface LoadingSpinnerProps {
  /** Announced to screen readers. Say what is loading, not just "loading". */
  labelKey: TranslationKey;
  className?: string;
}

/**
 * Centred loading indicator.
 *
 * `role="status"` and the label live on the CONTAINER, matching the existing pattern in
 * ChatMessages. An `aria-label` on the bare icon is not reliably announced: nothing
 * prompts assistive tech to read a non-interactive, non-live element that simply appears.
 *
 * `motion-reduce:animate-none` leaves a solid icon — still a clear "working" signal for
 * users who have asked for reduced motion.
 */
export const LoadingSpinner = ({ labelKey, className }: LoadingSpinnerProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-label={t(labelKey)}
      className={cn("flex flex-1 items-center justify-center py-24", className)}
    >
      <Loader2 className="h-8 w-8 animate-spin text-[#5DB075] motion-reduce:animate-none" />
    </div>
  );
};

export default LoadingSpinner;
